import config from 'config';
import buildAuthToken from 'utils/buildauthtoken';
import { i18n } from 'utils/i18n-util';

const {
	HOST: { APIM_SUBSCRIPTION_KEY },
	HOST: { BASE_APIM_URL }
} = config;

export const API_ERROR_MESSAGE = i18n('msg.err.something.went.wrong');
export const API_LOAD_ERROR_MESSAGE = i18n('msg.err.cannot.load.token');
export const NO_CLIENT_SELECTION_MESSAGE = i18n('msg.err.select.client');
export const BANNER_ERROR_MESSAGE = i18n('msg.err.correct.errors.to.continue');

export let STANDARD_HEADERS = {
	Accept: 'application/json',
	'Content-Type': 'application/json',
	pragma: 'no-cache',
	'cache-control': 'no-cache'
};

let FORM_DATA_HEADERS = {
	Accept: 'application/json, text/javascript, */*',
	pragma: 'no-cache',
	'cache-control': 'no-cache'
};

let FORM_URLENCODED_DATA_HEADERS = {
	Accept: 'application/json, text/javascript, */*',
	'Content-Type': 'application/x-www-form-urlencoded',
	pragma: 'no-cache',
	'cache-control': 'no-cache'
};

const DOWNLOAD_PDF_HEADERS = (filename) => {
	return {
		Accept: 'application/pdf',
		'Content-Type': 'application/pdf',
		'Content-Disposition': 'inline; filename=' + filename,
		pragma: 'no-cache',
		'cache-control': 'no-cache'
	};
};

export const METHODS = {
	GET: 'get',
	POST: 'post',
	PUT: 'put',
	DELETE: 'delete'
};

const defaultHeadersForType = (type = 'standard', filename) => {
	if (type === 'form') {
		return FORM_DATA_HEADERS;
	} else if (type === 'form-urlencoded') {
		return FORM_URLENCODED_DATA_HEADERS;
	} else if (type === 'file-upload') {
		return {};
	} else if (type === 'download-pdf') {
		return DOWNLOAD_PDF_HEADERS(filename);
	}
	return STANDARD_HEADERS;
};

export const HTTP_HEADERS = (type = 'standard', filename = '') => {
	let _headers = defaultHeadersForType(type, filename);
	_headers = Object.assign(_headers, {
		'Ocp-Apim-Subscription-Key': APIM_SUBSCRIPTION_KEY,
		authorization: `${buildAuthToken()}`
	});

	return {
		GET: {
			method: METHODS.GET,
			mode: 'cors',
			headers: _headers,
			credentials: 'include'
		},
		POST: {
			method: METHODS.POST,
			mode: 'cors',
			headers: _headers,
			credentials: 'include'
		},
		PUT: {
			method: METHODS.PUT,
			mode: 'cors',
			headers: _headers,
			credentials: 'include'
		},
		DELETE: {
			method: METHODS.DELETE,
			mode: 'cors',
			headers: _headers,
			credentials: 'include'
		}
	};
};

export const API_URL = {
	API: `/api`,
	ACCOUNTS: `/accounts`,
	STS: `/sts/`,
	PENDO_SERVICE: `/pendoservice`,
	MAPPING: '/FileImportMapping',
	PROCESSING: '/FileImportProcessing',
	REPORTING: '/FileImportReporting',
	COMPANY: '/Company',
	APIM_ROOT: (api) => {
		return process.env.NODE_ENV === 'production' ? `${BASE_APIM_URL}${api}` : api;
	}
};

export const GetApiErrorMsg = (jsonData, statusCode) => {
	let errorMessage = i18n('msg.err.something.went.wrong');
	if (statusCode === 401 || statusCode === 403) {
		errorMessage = i18n('msg.err.permissions');
	} else if (Boolean(jsonData)) {
		errorMessage = jsonData.detail;
		if (Boolean(jsonData.errors)) {
			let validationErrors = Object.values(jsonData.errors);
			let uniqueValidationErrors = [...new Set(validationErrors)]; //remove duplicates
			if (Boolean(uniqueValidationErrors)) {
				errorMessage = uniqueValidationErrors.join(', ');
			}
		}
	}
	return errorMessage;
};
